
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/paypal-rewards",
      function () {
        return require("private-next-pages/mobiworkx/paypal-rewards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/paypal-rewards"])
      });
    }
  